import React, { type ReactNode } from 'react';
import AgreeBlock from '../../../Agreement/AgreeBlock';
import SubmitOrderButton from '../SubmitOrderButton';
import styles from './submitAgreement.module.css';

type Props = {
  children: ReactNode;
};

const SubmitAgreement = (props: Props) => {
  const { children } = props;

  return (
    <div>
      <AgreeBlock />
      <SubmitOrderButton className={styles.submitButtonDesktop}>
        {children}
      </SubmitOrderButton>
    </div>
  );
};

export default SubmitAgreement;
